<template>
  <div
    class="flex flex-column justify-center vh-100"
    style="padding-right: 6vw;"
  >
    <BgLeaves
      v-if="brand === 'lh'"
      :position="[0, 0, 0, 1]"
      :inset="20"
      :trigger="leaves"
    />
    <transition-group
      @enter="animEnterSlider"
      @leave="animLeaveSlider"
      tag="div"
      class="w-100 relative vh-100"
      style="flex-grow: 1; margin-top: 9%;"
    >
      <TabContent
        v-show="activeTab === index"
        v-for="(item, index) in content"
        v-touch:swipe.left="swipeLeft"
        v-touch:swipe.right="swipeRight"
        :key="index"
        :brand="brand"
        :content="item"
        :button="true"
      />
    </transition-group>
    <NavSecondary
      :brand="brand"
      :icon="icon"
      :items="nav"
      title="Purchase Options"
    />
  </div>
</template>

<script>
import NavSecondary from '@/components/property/NavSecondary'
import TabContent from '@/components/property/TabContent'
import BgLeaves from '@/components/BgLeaves.vue'

import transitions from '../../transitions.js'

export default {
  name: 'PurchaseOptions',
  components: {
    NavSecondary,
    TabContent,
    BgLeaves
  },
  props: {
    brand: {
      type: String,
      default: 'lh'
    }
  },
  data () {
    return {
      leaves: false,
      icon: require('@/assets/img/icon-shared.svg')
    }
  },
  computed: {
    content () {
      if (this.$store.state.content != null) {
        return this.$store.state.content.purchaseOptions
      } else {
        return null
      }
    },
    nav () {
      const nav = []
      this.$store.state.content.purchaseOptions.forEach(element => {
        nav.push(element.title)
      })
      return nav
    },
    activeTab () {
      return this.$store.state.activeTab
    },
    prevTab () {
      return this.$store.state.prevTab
    }
  },
  mounted () {
    this.$store.commit('setPurchaseLength', this.content.length)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
      vm.$store.commit('setActiveTab', 0)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  },
  methods: {
    swipeLeft () {
      if (this.activeTab < this.content.length - 1) {
        this.$store.commit('setActiveTab', this.activeTab + 1)
      }
    },
    swipeRight () {
      if (this.activeTab > 0) {
        this.$store.commit('setActiveTab', this.activeTab - 1)
      }
    },
    animEnterSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeInRight(el, done)
      } else {
        transitions.fadeInLeft(el, done)
      }
    },
    animLeaveSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeOutLeft(el, done)
      } else {
        transitions.fadeOutRight(el, done)
      }
    }
  }
}
</script>
